<template>
    <v-dialog :value="value" @input="$emit('input', $event)" max-width="500px">
        <v-card>
            <v-card-title>{{ formTitle }}</v-card-title>
            <v-card-text class="pa-0">
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field v-model="localItem.descrizione" label="Descrizione" hide-details />
                        </v-col>

                        <v-col cols="12" sm="4">
                            <v-select v-model="localItem.tipologia" :items="tipoImportoOptions" label="Tipo Importo"
                                hide-details />
                        </v-col>

                        <v-col cols="6" sm="4">
                            <v-text-field v-model="localItem.data" label="Data" hide-details
                                style="max-width: 160px !important;" type="date" event-color="primary" />
                        </v-col>

                        <v-col cols="6" sm="4">
                            <v-menu v-model="menuOrario" :close-on-content-click="false" offset-y max-width="290px"
                                min-width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="localItem.orario" label="Orario" v-bind="attrs" clearable
                                        @blur="normalizeTime" hide-details>
                                        <template v-slot:prepend>
                                            <v-icon tabindex="-1" @click="menuOrario = true">
                                                access_time
                                            </v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-time-picker v-if="menuOrario" v-model="localItem.orario" full-width
                                    @click:minute="menuOrario = false" format="24hr" hide-details />
                            </v-menu>
                        </v-col>

                        <v-col cols="6" sm="6">
                            <v-text-field v-model.number="localItem.entrata" label="Entrate" type="number" prefix="€"
                                :rules="[v => v >= 0 || 'Valore deve essere positivo']" hide-details />
                        </v-col>

                        <v-col cols="6" sm="6">
                            <v-text-field v-model.number="localItem.uscita" label="Uscite" type="number" prefix="€"
                                :rules="[v => v >= 0 || 'Valore deve essere positivo']" hide-details />
                        </v-col>

                        <v-col cols="12" sm="12">
                            <v-textarea v-model="localItem.note" label="Note" rows="3" hide-details />
                        </v-col>

                        <v-col cols="12" sm="12" class="pb-0 pt-0">
                            <v-checkbox v-model="localItem.escludiCalcolo" label="Escludi dal calcolo" hide-details />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <v-btn color="blue darken-1" text @click="handleClose">
                    Annulla
                </v-btn>
                <v-btn color="blue darken-1" text @click="handleSave" :disabled="!isFormValid">
                    Salva
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "CashflowDialog",

    props: {
        value: {
            type: Boolean,
            required: true
        },
        editedItem: {
            type: Object,
            required: true
        },
        isNew: {
            type: Boolean,
            default: true
        }
    },

    data: () => ({
        localItem: {},
        menuData: false,
        menuOrario: false,
        tipoImportoOptions: ['Reale', 'Previsionale', 'Banca']
    }),

    computed: {
        formTitle() {
            return this.isNew ? "Nuovo Record" : "Modifica Record";
        },

        formattedData() {
            if (!this.localItem.data) return '';
            const [year, month, day] = this.localItem.data.split('-');
            return `${day}/${month}/${year}`;
        },

        isFormValid() {
            return this.localItem.descrizione?.trim() &&
                this.localItem.data &&
                this.localItem.tipologia &&
                (this.localItem.entrata >= 0 || this.localItem.entrata === null) &&
                (this.localItem.uscita >= 0 || this.localItem.uscita === null);
        }
    },

    watch: {
        editedItem: {
            handler(newVal) {
                this.localItem = { ...newVal };
            },
            immediate: true,
            deep: true
        }
    },

    methods: {
        normalizeTime() {
            if (this.$functions?.normalizzaOra) {
                this.localItem.orario = this.$functions.normalizzaOra(this.localItem.orario);
            }
        },

        handleSave() {
            this.normalizeTime();
            this.$emit('save', { ...this.localItem });
        },

        handleClose() {
            this.$emit('close');
        }
    }
};
</script>